import React, { Component } from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import './styles/modalFiltersLive.scss';
import { Grid, Row, Column, cls, Heading } from '../../packages/components';
import { ColoredButton } from '../../packages/components/lib/ColoredButton';
import GridByCategorie from '../Epg/GridByCatetogorie';
import Device from '../../devices/device';
import Translator from '../../requests/apa/Translator';
import Asset from '../../requests/apa/Asset';


class ModalFilterLiveCategories extends Component {
    constructor(props) {
        super(props);
        this.modalProps = {
            childrenClassName: 'modal_full_height_categories',
        };
        this.keys = Device.getDevice().getKeys();
    }


    componentDidMount = () => {
        this.addListener();
    }

    componentWillUnmount = () => {
        this.removeListener();
    }


    handleKey = (e) => {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        switch (currentKey) {
            case 'YELLOW':
                e.preventDefault();
                e.stopPropagation();
                this.handleBack();
            break;
            case 'GREEN':
                e.preventDefault();
                e.stopPropagation();
                this.handleExit();
            break;
        }
    }

    addListener = () => {
        document.addEventListener('keydown', this.handleKey, true);
    }

    removeListener = () => {
        document.removeEventListener('keydown', this.handleKey, true);
    }

    onClick = (item) => {
        this.props && (typeof this.props.onClick === 'function') && this.props.handleClose(null,this.props.onClick(item));
    }

    handleBack = () => {
            this.props && (typeof this.props.handleBack === 'function') && this.props.handleBack();
    }
    handleExit = () => {
        this.props && (typeof this.props.handleExit === 'function') && this.props.handleClose(null, this.props.handleExit());
    }


    render (){
        return (
            <ModalWrapper {...this.modalProps}>
                <Grid className={cls(`grid_main_categories_filter`)}>
                    <Row className={cls(``)}>
                        <Column size={12} className={cls(`modal_filter_categories_button_colour`)}>
                        <ColoredButton color={'green'}
                            className={cls(`modal_filter_live_button_colour`,`modal_filter_live_button_colour_green`, `focusable`)}
                            onClick= {this.handleExit}>{Translator.get('top_head_option_button_exit','SALIR')}
                        </ColoredButton>
                        {<ColoredButton color={'yellow'}
                            className={cls(`modal_filter_live_button_colour`,`modal_filter_live_button_colour_yellow`,`focusable`)}
                            onClick= {this.handleBack}
                            imgSrc = {Asset.get('top_head_option_back', '')}
                            >{Translator.get('top_head_option_button_return','REGRESAR')}
                        </ColoredButton>}
                        </Column>
                    </Row>
                </Grid>
                <Grid className={cls(`grid_main_categories_title`)}>
                    <Heading size={2} className={cls(`grid_main_categories_title_h`)}>{this.props.title || ''}</Heading>
                </Grid>
                <GridByCategorie items={this.props.filters} rows={3} cols={4} onClick = {this.onClick}/>
            </ModalWrapper>
        );
    }
}

export default withOnClose(ModalFilterLiveCategories);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalFilterLiveCategories.jsx